import React from 'react';
import queryString from 'query-string';
import AppBar from '@material-ui/core/AppBar';
import GridContainer from '../../../@jumbo/components/GridContainer';
import Backdrop from '@material-ui/core/Backdrop';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import SidebarButtons from '../../../@jumbo/components/AppLayout/partials/SideBar/SIdebarButtons';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import { DatePicker, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core/';
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { Alert, AlertTitle } from '@material-ui/lab';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import LanguageSwitcher from '../../Booking/LanguageSwitcher';
import Typography from '@material-ui/core/Typography';
import { Home, Mail, Phone } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { formatPrice } from '../../../@jumbo/utils/commonHelper';
import Swal from 'sweetalert2';
import Checkbox from '@material-ui/core/Checkbox';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.quickReservation'} />, isActive: true },
];

function MyAlert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

const useStyles = theme => ({
  card: {
    overflow: 'unset',
    marginBottom: theme.typography.pxToRem(32),
  },
  title: {
    padding: '10px',
  },
  indentClass: {
    paddingLeft: '50px',
  },
  cardContent: {
    position: 'relative',
    paddingBottom: 0,
  },
  cardContentInner: {
    position: 'relative',
    paddingBottom: 0,
  },
  formControl: {
    margin: theme.spacing(2),
  },
  guestPrice: {
    minWidth: 200,
  },
  currency: {
    minWidth: 200,
    marginLeft: 10,
  },
});

class PriceList extends React.Component {
  useStyles = makeStyles(theme => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));
  constructor(props) {
    super(props);
    //    const classes = this.useStyles();
    /*const { authUser } = useSelector(({ auth }) => auth);*/
    var languageData = [];
    var languageItem = {};
    languageItem = {
      languageId: 'croatian',
      locale: 'hr',
      name: 'Hrvatski',
      icon: 'hr',
    };
    languageData.push(languageItem);
    var languageItem = {};
    languageItem = {
      languageId: 'english',
      locale: 'en',
      name: 'English',
      icon: 'us',
    };
    languageData.push(languageItem);
    this.state = {
      languageData: languageData,
      posId: this.props.match.params.posId,
      hotelId: this.props.match.params.hotelId,
      securityCode: this.props.match.params.securityCode,
      groups: [],
      properties: [],
      items: [],
      cart: [],
      step: 0,
      telephone: '',
      firstName: '',
      lastName: '',
      comment: '',
      roomNumber: '',
      email: '',
      allowedMethods: ['wspay'],
      delivery: 1,
      deliveryDisabled: true,
      pMethod: 'wspay',
      pMethod2: 'room',
    };
    this.addItem = this.addItem.bind(this);
    this.order = this.order.bind(this);
    this.inCart = this.inCart.bind(this);
  }

  handleChange(name, value) {
    if (value == null) return;
    this.setState({ [name]: value }, () => {
      //   this.updateRooms();
    });
  }

  doAction(name, value) {
    if (name == null) return;
    if (name == 'Reset') {
      this.setState({ idPOS: 0 });
    } else {
      this.setState({ [name]: value }, () => {
        //   this.updateRooms();
      });
    }
  }

  loadReservation(bid, control) {
    if (this.state.hotelId == null || this.state.posId == null) return;
    var request = {
      Action: 'getPOSOrder',
      hotelId: this.state.hotelId,
      securityCode: this.state.securityCode,
      securityCode2: control,
      posId: this.state.posId,
      orderId: bid,
    };
    axios.post('https://secure.webbookingpro.com/bapi/booking.php', request).then(res => {
      var x = 0;
      if (res.data.status == 0) x = 1;
      var y = [];
      y.push(res.data.info);

      this.setState({ properties: y, step: 3, errorCode: x, bookingNumber: bid });
    });
  }
  loadPriceList() {
    if (this.state.hotelId == null || this.state.posId == null) return;
    var request = {
      Action: 'getPOS',
      hotelId: this.state.hotelId,
      securityCode: this.state.securityCode,
      posId: this.state.posId,
    };
    axios.post('https://secure.webbookingpro.com/bapi/booking.php', request).then(res => {
      var x = [];
      x.push(res.data.info);
      this.setState({ step: 0, cart: [], properties: x, pos: res.data.pos, groups: res.data.groups, items: res.data.items });
    });
  }

  componentDidMount() {
    const { currentPage, setCurrentPage } = this.context;
    const { intl } = this.props;
    const params = queryString.parse(window.location.search.substring(1));

    if (params != null && params.bid != null) {
      var bookingId = params.bid;
      var control = params.control;
      this.loadReservation(bookingId, control);
    } else this.loadPriceList();
  }

  addItem(item, quantity) {
    this.setState(prevState => {
      const oitems = [...prevState.cart];
      var index = oitems.findIndex(itemx => itemx.id == item.id);
      if (index == -1) {
        if (quantity > 0) oitems.push({ id: item.id, quantity: quantity });
      } else {
        oitems[index].quantity += quantity;
        if (oitems[index].quantity <= 0) oitems.splice(index, 1);
      }
      return { cart: oitems };
    });
  }

  inCart(id) {
    var index = this.state.cart.findIndex(itemx => itemx.id == id);
    if (index != -1 && this.state.cart[index].quantity > 0) return true;
    else return false;
  }

  order() {
    const { intl } = this.props;
    var request = {
      Action: 'newPOSOrder',
      SecurityCode: this.state.securityCode,
      Data: {
        hotelId: this.state.hotelId,
        posId: this.state.posId,
        cart: this.state.cart,
        guestInfo: {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          phone: this.state.telephone,
        },
        pMethod: this.state.pMethod,
        pMethod2: this.state.pMethod2,
        delivery: this.state.delivery ? 1 : 0,
        comment: this.state.comment,
        roomNumber: this.state.roomNumber,
      },
    };
    var message = '';
    var canAdd = true;
    if ((this.state.firstName == null || this.state.firstName.length < 2) && message == '') {
      message = intl.formatMessage({ id: '_FIRST_NAME_EMPTY_ALERT' });
      canAdd = false;
    }
    if ((this.state.lastName == null || this.state.lastName.length < 2) && message == '') {
      message = intl.formatMessage({ id: '_LAST_NAME_EMPTY_ALERT' });
      canAdd = false;
    }
    if ((this.state.roomNumber == null || this.state.roomNumber.length < 1) && message == '') {
      message = intl.formatMessage({ id: '_ROOM_NUMBER_EMPTY' });
      canAdd = false;
    }
    if ((this.state.email == null || this.state.email.length < 3 || this.state.email.indexOf('@') < 0) && message == '') {
      message = intl.formatMessage({ id: '_EMAIL_IS_WRONG' });
      canAdd = false;
    }
    if ((this.state.telephone == null || this.state.telephone.length < 6) && message == '') {
      message = intl.formatMessage({ id: '_PHONE_EMPTY_ALERT' });

      canAdd = false;
    }

    if (message != '') {
      Swal.fire({
        title: intl.formatMessage({ id: '_MESSAGE' }),
        text: message,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: intl.formatMessage({ id: 'ok' }),
      }).then(result => {
        //this.doRefresh();
      });
    }

    if (canAdd == false) return;
    axios.post(`https://secure.webbookingpro.com/bapi/booking.php`, request).then(res => {
      if (res.data.result == 'true') {
        var myTitle = '';
        //if (res.data.data.properties.length > 0) myTitle = res.data.data.properties[0].title['en'];
        /*else*/ myTitle = 'WebBookingPro';

        this.setState({
          errorCode: 0,
          bookingNumber: res.data.bookingNumber,
          step: 3,
          requirePaymentStep: res.data.paymentUrl != null,
          hotelEmail: res.data.contactEmail,
        });
        if (res.data.paymentUrl != null && res.data.paymentUrl != '') {
          window.location = res.data.paymentUrl;
        }
      } else {
        this.setState({ errorCode: res.data.errorCode });
      }
    });
  }

  render() {
    console.log('x1');
    const { classes } = this.props;
    const { intl } = this.props;
    const language = this.context.locale.locale;
    var isMobile = 0;
    if (window.innerWidth < 800) {
      /* if (/ipad|iphone|ipod|android|ie|blackberry|fennec/.test(navigator.userAgent.toLowerCase()))*/ isMobile = 1;
    }
    var mystyle = {};
    var total = 0;
    this.state.cart.map(
      function(item) {
        var itemx = this.state.items.filter(itemz => itemz.id == item.id)[0];
        total += item.quantity * parseFloat(itemx.price);
      }.bind(this),
    );
    return (
      <>
        <Grid container style={mystyle}>
          <Grid item xs={12}>
            {this.state.properties.length == 1 && (
              <CmtCard className={classes.card}>
                <CmtCardContent className={classes.cardContent2}>
                  <GridContainer>
                    <Grid
                      item
                      xl={6}
                      sm={6}
                      xs={12}
                      style={{ margin: 'auto', width: '50%', textAlign: isMobile == 1 ? 'center' : 'right' }}>
                      <>
                        <a href={this.state.properties[0].website}>
                          <img src={this.state.properties[0].logoImage} className={classes.logoImage} />
                        </a>
                      </>
                    </Grid>
                    <Grid
                      item
                      xl={6}
                      sm={6}
                      xs={12}
                      style={{ margin: 'auto', width: '50%', textAlign: isMobile == 1 ? 'center' : 'left' }}>
                      <Typography component="label" className={classes.title + ' wbpTitle ' + classes.titleSize2}>
                        {this.state.properties[0].name}
                      </Typography>
                      <br />
                      {this.state.properties[0].phone != '' && (
                        <>
                          <Home size="small" />
                          <Typography component="label" className={classes.title2 + ' wbpTitle2 ' + classes.titleSize}>
                            {this.state.properties[0].address}
                            {this.state.properties[0].address != '' && ', ' + this.state.properties[0].city}
                            {this.state.properties[0].city != '' && ', ' + this.state.properties[0].country}
                          </Typography>
                          <br />
                        </>
                      )}
                      <br />
                      {this.state.properties[0].phone != '' && (
                        <>
                          <Phone size="small" />
                          <a href={'tel://' + this.state.properties[0].phone}>
                            <Typography component="label" className={classes.titlex2 + ' wbpTitle2 ' + classes.titleSize2}>
                              {this.state.properties[0].phone}
                            </Typography>
                          </a>

                          <br />
                        </>
                      )}
                      {this.state.properties[0].email != '' && (
                        <>
                          <Mail />
                          <a href={'mailto://' + this.state.properties[0].email}>
                            <Typography component="label" className={classes.titlex2}>
                              {this.state.properties[0].email}
                            </Typography>
                          </a>
                        </>
                      )}
                    </Grid>
                  </GridContainer>
                </CmtCardContent>
              </CmtCard>
            )}

            <CmtCard className={classes.card}>
              <CmtCardContent className={classes.cardContent2}>
                <Box>
                  <LanguageSwitcher languageData={this.state.languageData} />
                </Box>
                <Box>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={6}
                      xl={6}
                      sm={6}
                      style={{ margin: 'auto', width: '50%', textAlign: isMobile == 1 ? 'left' : 'left' }}>
                      {this.state.step == 1 && this.state.cart.length > 0 && (
                        <Button variant="contained" size="small" color="primary" onClick={() => this.setState({ step: 0 })}>
                          <IntlMessages id="_BUTTON_BACK" />
                        </Button>
                      )}
                      {this.state.step == 2 && this.state.cart.length > 0 && (
                        <Button variant="contained" size="small" color="primary" onClick={() => this.setState({ step: 1 })}>
                          <IntlMessages id="_BUTTON_BACK" />
                        </Button>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      xl={6}
                      sm={6}
                      style={{ margin: 'auto', width: '50%', textAlign: isMobile == 1 ? 'right' : 'right' }}>
                      {this.state.step == 0 && this.state.cart.length > 0 && (
                        <Button
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={() => this.setState({ step: 1 })}>
                          <IntlMessages id="_NEXT" />
                        </Button>
                      )}
                      {this.state.step == 1 && this.state.cart.length > 0 && (
                        <Button
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={() => this.setState({ step: 2 })}>
                          <IntlMessages id="_NEXT" />
                        </Button>
                      )}
                      {this.state.step == 2 && this.state.cart.length > 0 && (
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.order()}>
                          <IntlMessages id="confirmOrder" />
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                  <br />

                  {this.state.groups.map(group => (
                    <>
                      {this.state.step == 0 && (
                        <>
                          {group.name[language] != 'Default' &&
                            this.state.items.filter(item => item.groupId == group.id).length > 0 && (
                              <AppBar position="static">
                                {' '}
                                <Typography variant="h2" className={classes.title}>
                                  {group.name[language]}
                                </Typography>
                              </AppBar>
                            )}
                          {this.state.items
                            .filter(item => item.groupId == group.id)
                            .map(item => (
                              <GridContainer>
                                <Grid
                                  item
                                  xs={12}
                                  xl={6}
                                  sm={6}
                                  style={{ margin: 'auto', width: '50%', textAlign: isMobile == 1 ? 'center' : 'left' }}>
                                  <Typography variant="h4" className={classes.title}>
                                    {this.state.cart.filter(itemx => itemx.id == item.id).length == 1 && (
                                      <>
                                        {this.state.cart.filter(itemx => itemx.id == item.id)[0].quantity}
                                        {' x '}
                                      </>
                                    )}
                                    {item.name[language]}
                                  </Typography>
                                  <br />
                                  <IconButton onClick={() => this.addItem(item, 1)}>
                                    <AddIcon />
                                  </IconButton>
                                  {this.inCart(item.id) && (
                                    <IconButton onClick={() => this.addItem(item, -1)}>
                                      <RemoveIcon />
                                    </IconButton>
                                  )}
                                  <br />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  xl={6}
                                  sm={6}
                                  style={{ margin: 'auto', width: '50%', textAlign: isMobile == 1 ? 'center' : 'right' }}>
                                  <Typography variant="h4" className={classes.title}>
                                    {this.state.items.filter(itemx => itemx.id == item.id)[0].price}
                                    {' EUR'}
                                  </Typography>
                                </Grid>
                              </GridContainer>
                            ))}
                        </>
                      )}
                    </>
                  ))}
                  {this.state.step == 1 && (
                    <>
                      <AppBar position="static">
                        {' '}
                        <Typography variant="h6" className={classes.title}>
                          <IntlMessages id="Review" />
                        </Typography>
                      </AppBar>
                      <TableContainer className={classes.container}>
                        <Table stickyHeader aria-label="sticky table" size="small">
                          <TableBody>
                            {this.state.cart.map(item => (
                              <TableRow>
                                <TableCell>
                                  {item.quantity} {' x '}
                                </TableCell>
                                <TableCell>
                                  {this.state.items.filter(itemx => itemx.id == item.id)[0].name[language]}
                                </TableCell>
                                <TableCell align="right">
                                  {formatPrice(this.state.items.filter(itemx => itemx.id == item.id)[0].price, language)}
                                  {' EUR'}
                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell align="right">
                                <IntlMessages id="_TOTAL" />
                                {': '}
                                {formatPrice(total, language)}
                                {' EUR'}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  )}
                  {this.state.step == 3 && (
                    <>
                      <Box className={classes.cardContentInner}>
                        {this.state.errorCode == 0 && (
                          <MyAlert severity="success">
                            <IntlMessages id="_BOOKING_WAS_COMPLETED_MSG" />
                          </MyAlert>
                        )}
                        {this.state.errorCode == 1 && (
                          <MyAlert severity="error">
                            <IntlMessages id="_ORDER_ERROR" />
                            <br />
                            <IntlMessages id="_LEGEND_PAYMENT_ERROR" />
                          </MyAlert>
                        )}
                      </Box>
                      {this.state.errorCode == 0 && (
                        <Box className={classes.cardContentInner}>
                          <IntlMessages id="_ORDER_NUMBER" /> {this.state.bookingNumber}
                        </Box>
                      )}
                      {this.state.errorCode == 0 && (
                        <Box className={classes.cardContentInner}>
                          <IntlMessages id="bookingSuccessMessage2" /> {this.state.hotelEmail}
                        </Box>
                      )}
                      <Box className={classes.cardContentInner}>
                        <Button variant="contained" color="primary" size="large" onClick={() => this.loadPriceList()}>
                          <IntlMessages id="createAnotherOrder" />
                        </Button>
                      </Box>
                    </>
                  )}
                  {this.state.step == 2 && (
                    <>
                      <Box>
                        <Grid container spacing={2}>
                          <Grid item xs={12} xl={6} md={6}>
                            <FormControl variant="filled" className={classes.formControl} fullWidth>
                              <TextField
                                required
                                id="searchResId"
                                name="searchResId"
                                label=<IntlMessages id="_FIRST_NAME" />
                                margin="normal"
                                defaultValue=""
                                fullWidth
                                onChange={event => this.handleChange('firstName', event.target.value)}
                                value={this.state.firstName}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} xl={6} md={6}>
                            <FormControl variant="filled" className={classes.formControl} fullWidth>
                              <TextField
                                required
                                id="searchResId"
                                name="searchResId"
                                label=<IntlMessages id="_LAST_NAME" />
                                margin="normal"
                                defaultValue=""
                                fullWidth
                                value={this.state.lastName}
                                onChange={event => this.handleChange('lastName', event.target.value)}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} xl={6} md={6}>
                            <FormControl variant="filled" className={classes.formControl} fullWidth>
                              <TextField
                                required
                                id="searchResId"
                                name="searchResId"
                                label=<IntlMessages id="_PHONE" />
                                margin="normal"
                                defaultValue=""
                                fullWidth
                                value={this.state.telephone}
                                onChange={event => this.handleChange('telephone', event.target.value)}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} xl={6} md={6}>
                            <FormControl variant="filled" className={classes.formControl} fullWidth>
                              <TextField
                                required
                                id="searchResId"
                                name="searchResId"
                                label=<IntlMessages id="_EMAIL" />
                                margin="normal"
                                fullWidth
                                defaultValue=""
                                value={this.state.email}
                                onChange={event => this.handleChange('email', event.target.value)}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} xl={6} md={6}>
                            <FormControl variant="filled" className={classes.formControl} fullWidth>
                              <TextField
                                required
                                id="searchResId"
                                name="searchResId"
                                label=<IntlMessages id="_TABLE" />
                                margin="normal"
                                defaultValue=""
                                fullWidth
                                value={this.state.roomNumber}
                                onChange={event => this.handleChange('roomNumber', event.target.value)}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} xl={12} md={12}>
                            <TextField
                              label={<IntlMessages id="_ADDITIONAL_INFO" />}
                              id="guestComment"
                              name="guestComment"
                              margin="normal"
                              rows={6}
                              variant="filled"
                              fullWidth
                              multiline="true"
                              value={this.state.comment}
                              onChange={event => this.handleChange('comment', event.target.value)}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                      <Box>
                        <FormLabel component="legend">
                          <IntlMessages id="_PAYMENT" />
                        </FormLabel>
                        <RadioGroup
                          aria-label="gender"
                          name="gender1"
                          value={this.state.pMethod}
                          onChange={event => this.handleChange('pMethod', event.target.value)}>
                          <FormControlLabel
                            disabled={this.state.allowedMethods.filter(item => item == 'pickup').length == 0}
                            value={'pickup'}
                            control={<Radio />}
                            label=<IntlMessages id="_PICKUP" />
                          />
                          {this.state.pMethod == 'pickup' && (
                            <ul>
                              <Box className={classes.indentClass}>
                                <FormLabel component="legend">
                                  <IntlMessages id="_PAYMENT_METHOD" />
                                </FormLabel>
                                <RadioGroup
                                  aria-label="gender"
                                  name="gender1"
                                  value={this.state.pMethod2}
                                  onChange={event => this.handleChange('pMethod2', event.target.value)}>
                                  <FormControlLabel
                                    value={'room'}
                                    control={<Radio />}
                                    label={<IntlMessages id="onRoom" />}
                                  />
                                  <FormControlLabel value={'cash'} control={<Radio />} label={<IntlMessages id="cash" />} />
                                  <FormControlLabel
                                    value={'cc'}
                                    control={<Radio />}
                                    label={<IntlMessages id="bycreditCard2" />}
                                  />
                                </RadioGroup>
                              </Box>
                            </ul>
                          )}
                          {this.state.allowedMethods.filter(item => item == 'wspay').length == 1 && (
                            <FormControlLabel value={'wspay'} control={<Radio />} label=<IntlMessages id="bycreditCard" /> />
                          )}
                          {this.state.pMethod == 'wspay' && (
                            <>Redirects to WSPay/Monri Payment Gateway after confirming Order.</>
                          )}
                        </RadioGroup>
                      </Box>
                      <Box>
                        <FormLabel component="legend">
                          <IntlMessages id="delivery" />
                        </FormLabel>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={this.state.deliveryDisabled == 1}
                              checked={this.state.delivery}
                              onChange={event => this.handleChange('delivery', event.target.checked)}
                            />
                          }
                          label=<IntlMessages id="delivery2" />
                        />
                      </Box>

                      <Box></Box>
                    </>
                  )}
                </Box>
              </CmtCardContent>
            </CmtCard>
            {this.state.properties.length == 1 && (
              <CmtCard className={classes.card}>
                <CmtCardContent className={classes.cardContent2}>
                  <GridContainer>
                    <Grid item xl={12} sm={12} xs={12} style={{ margin: 'auto', width: '50%', textAlign: 'center' }}>
                      <Typography component="label" className={classes.title + ' wbpTitle ' + classes.titleSize2}>
                        {this.state.properties[0].companyname}
                        {' - '}
                        {this.state.properties[0].companyaddress}
                        {' - '}
                        {this.state.properties[0].companycity}
                        {' - '}
                        {'OIB: '}
                        {this.state.properties[0].companytaxid}
                      </Typography>
                      <br />
                      <Typography component="label" className={classes.title + ' wbpTitle ' + classes.titleSize2}>
                        <a href={this.state.properties[0].privacyLink}>Privacy Policy</a>
                      </Typography>
                    </Grid>
                  </GridContainer>
                </CmtCardContent>
              </CmtCard>
            )}
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

PriceList.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(PriceList)));
/*

 */
